import React from 'react';

export default function FooterShapes() {
    return (
        <div className="footer__shapes">
            <svg
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 480 301"
            >
                <g clipPath="url(#a)">
                    <path
                        d="M359.549 181.303H239.852V301h119.697V181.303Z"
                        fill="#FFCF3F"
                    />
                    <path
                        d="M419.626 181.303c33.182 0 60.077-26.9 60.077-60.077 0-33.178-26.895-60.078-60.077-60.078s-60.077 26.9-60.077 60.078c0 33.177 26.895 60.077 60.077 60.077Z"
                        fill="#8428FA"
                    />
                    <path
                        d="M359.549 61.148H239.852v120.155L359.549 61.148Z"
                        fill="#62CC74"
                    />
                    <path
                        d="M359.549 120.997H299.7v60.306l59.849-60.306Z"
                        fill="#62CC74"
                    />
                    <path
                        d="M479.703 61.148H360.006a59.848 59.848 0 0 1 119.697 0Z"
                        fill="#FFA6D0"
                    />
                    <path
                        d="M0 301a59.847 59.847 0 0 1 59.849-59.849V301H0Z"
                        fill="#62CC74"
                    />
                    <path
                        d="M59.849 301a59.848 59.848 0 0 1 59.848-59.849V301H59.849Z"
                        fill="#FFA6D0"
                    />
                    <path
                        d="M179.774 181.303 119.697 301h120.154l-60.077-119.697Z"
                        fill="#FF2727"
                    />
                    <path
                        d="M379.765 281.012h-19.988V301h19.988v-19.988ZM379.765 241.037h-19.988v19.988h19.988v-19.988ZM379.765 201.062h-19.988v19.988h19.988v-19.988ZM399.753 261.025h-19.988v19.988h19.988v-19.988ZM399.753 221.05h-19.988v19.987h19.988V221.05ZM399.753 181.074h-19.988v19.988h19.988v-19.988ZM419.74 281.012h-19.987V301h19.987v-19.988ZM419.74 241.037h-19.987v19.988h19.987v-19.988ZM419.74 201.062h-19.987v19.988h19.987v-19.988ZM439.728 261.025H419.74v19.988h19.988v-19.988ZM439.728 221.05H419.74v19.987h19.988V221.05ZM439.728 181.074H419.74v19.988h19.988v-19.988Z"
                        fill="#fff"
                    />
                    <path
                        d="M459.715 281.012h-19.987V301h19.987v-19.988ZM459.715 241.037h-19.987v19.988h19.987v-19.988ZM459.715 201.062h-19.987v19.988h19.987v-19.988ZM479.703 261.025h-19.987v19.988h19.987v-19.988ZM479.703 221.05h-19.987v19.987h19.987V221.05ZM479.703 181.074h-19.987v19.988h19.987v-19.988Z"
                        fill="#fff"
                    />
                    <path
                        d="M359.777 61.148H239.852"
                        stroke="#fff"
                        strokeWidth=".699"
                        strokeMiterlimit="10"
                    />
                    <path
                        d="M299.814 1.186v59.962M257.413 18.747l42.402 42.401M342.216 18.747l-42.402 42.401M247.888 31.164l51.927 29.98M329.798 9.217l-29.984 51.927M284.295 3.228l15.519 57.92M357.735 45.629l-57.921 15.52M351.746 31.164l-51.932 29.98M269.831 9.217l29.984 51.927M241.894 45.629l57.921 15.52M315.334 3.228l-15.52 57.92"
                        stroke="#fff"
                        strokeWidth="1.371"
                        strokeMiterlimit="10"
                    />
                </g>
                <defs>
                    <clipPath id="a">
                        <path
                            fill="#fff"
                            transform="translate(0 .843)"
                            d="M0 0h479.703v300.157H0z"
                        />
                    </clipPath>
                </defs>
            </svg>
        </div>
    );
}
